import React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import OwnerSidebarNav from './SidebarNav';

const OwnerSidebar = ({ mobileOpen, handleDrawerTransitionEnd, handleDrawerClose, drawerWidth }) => {

	return (
		<Box
			component="nav"
			sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
			className="bg-gray-100"
			aria-label="mailbox folders"
			style={{ zIndex: 0 }}
		>
			<Drawer
				variant="temporary"
				open={mobileOpen}
				onTransitionEnd={handleDrawerTransitionEnd}
				onClose={handleDrawerClose}
				ModalProps={{
					keepMounted: true
				}}
				PaperProps={{
					sx: {
						backgroundColor: '#f6f6f6'
					}
				}}
				sx={{
					display: { xs: 'block', sm: 'none' },
					'& .MuiDrawer-paper': {
						boxSizing: 'border-box',
						width: drawerWidth
					}
				}}
			>
				<OwnerSidebarNav />
			</Drawer>
			<Drawer
				variant="permanent"
				PaperProps={{
					sx: {
						backgroundColor: '#f6f6f6',
					}
				}}
				sx={{
					display: { xs: 'none', sm: 'block' },
					'& .MuiDrawer-paper': {
						boxSizing: 'border-box',
						width: drawerWidth
					},
					bgcolor: 'red',
				}}
				open
			>
				<OwnerSidebarNav />
			</Drawer>
		</Box>
	);
};

export default OwnerSidebar;
